





















import { Component, Prop, Vue } from 'vue-property-decorator';

import Alert from '@/components/Global/Alert.vue';
import AccordionList from '@/components/Global/Accordion/AccordionList.vue';

import Quotes, { Quote } from '@/services/Quotes';

import QuoteSummaryTable from './QuoteSummaryTable.vue';

@Component({
	components: {
		Alert,
		AccordionList,
		QuoteSummaryTable,
	},
})
export default class QuoteAccordionList extends Vue {
	@Prop({
		default: [],
		type: Array,
		validator(array) {
			return array.every(item => item instanceof Quote);
		},
	})
	private quotes: any;

	private resumeQuote(quoteId) {
		Quotes.resumeQuote(quoteId);
	}
}
